import React from 'react'
//import styles
import style from '../a.module.scss'
//import assets
import mentorHeroBackground from "../../../assets/Backgrounds/mentor-hero-background.svg";
import GradientText from "../../../components/GradientText/GradientText";
import teacher from "../../../assets/Illustrations/red-teacher.svg";
import menu from "../../../assets/Illustrations/green-menu.svg";
import group from "../../../assets/Illustrations/blue-group.svg";


const HeroSection = () =>{
    return (
        <div className={style.heroSection} style={{ backgroundImage: `url(${mentorHeroBackground})` }}>
            <div className={style.upperheroSection} >
                <h1>Find a mentor who can <br />suggest the right thing</h1>
            </div>
            <div className={style.lowerheroSection}>
                <h1>Experience the <br/> power of <GradientText title="Mentor" color1='#407BFF' color2='#6F2682'/></h1>
                <div className={style.subHeading}>
                    <div>
                        <img src={teacher} alt="icon"></img>
                        <p> Our secondary goal is to build a strong mentoring relationship </p>
                    </div>
                    <div>
                        <img src={menu} alt="icon"></img>
                        <p> Our secondary goal is to build a strong mentoring relationship </p>
                    </div>
                    <div>
                        <img src={group} alt="icon"></img>
                        <p> Our secondary goal is to build a strong mentoring relationship </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeroSection